import * as z from 'zod/mini';

export const walletProviderKeyMapSchema = z.record(z.string(), z.string());
